import { useDebounce } from '@react-hook/debounce'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import Swal from 'sweetalert2'
import { saveAs } from 'file-saver'
import {
  Button,
  ButtonToolbar,
  Col,
  Form,
  Image,
  InputGroup,
  OverlayTrigger,
  Row,
  Table,
  Tooltip
} from 'react-bootstrap'
import NavTitle from '../../nav-title'
import BtnBack from '../../btn-back'
import { BsSearch } from 'react-icons/bs'
import Autocomplete from '../../custom/autocomplete'
import editImg from '../../../images/Provident-Fund/Edit_Fill.svg'
import imgUser from '../../../images/user.png'
import { getEjipRoundsViewAllAPI } from '../../../services/ejip'
import Error_500 from '../../error/error-500'
import Error_false from '../../error/error-false'
import SpinnerLoading from '../../spinner-loading'
import { PaginationControl } from 'react-bootstrap-pagination-control'
import UseOrganization from '../../../hooks/use-org'
import CardCustom from '../../custom/card-custom'
import MedalEditMember from './detail/medal-edit-member'
import { createSpreadsheetBlob } from '../../../helper/spreadsheet/write-spreadsheet'
import { buildEjipAllMemberReportSheet } from '../../../helper/spreadsheet/ejip-all-member-report'
moment.locale('en')

export default function EjipAllMemberPage() {
  let [searchParams] = useSearchParams()
  const [isLoading, setIsLoading] = useState(true)
  const fundId = searchParams.get('id')

  const [search, setSearch] = useDebounce('', 1000)
  const [isModalOpenEditMember, setIsModalOpenEditMember] = useState(false)

  const [org, setOrg] = useState()
  const dataOrgs = UseOrganization()

  const totalLimits = 20
  const [page, setPage] = useState(1)
  const [totalRows, setTotalRows] = useState(0)
  const [bodyFilter, setBodyFilter] = useState()

  useEffect(() => {
    const body = {
      fundId,
      page: 1,
      orgId: '',
      size: totalLimits,
      search
    }
    if (fundId) {
      fnGetData(body)
    }
  }, [fundId, search])

  const [data, setData] = useState([])
  const fnGetData = async (body, isEx = false) => {
    try {
      if (!isEx) {
        setPage(body.page)
        setBodyFilter(body)
      }
      setIsLoading(true)
      const resp = await getEjipRoundsViewAllAPI(body)
      setIsLoading(false)
      if (!resp) return
      if (resp.status) {
        if (!isEx) {
          setData(resp.result ?? [])
          setTotalRows(resp.totalRows)
        } else {
          await exportExcel(
            resp.result.map((d, i) => {
              return {
                EmployeesID: d.code,
                Name: d.name_th,
                EntryDate: moment(d.entry_date).format('DD/MM/YYYY'),
                Rounds: d.round,
                Deducted: d.percentage,
                ResignationDate: d.resignation_date
                  ? moment(d.resignation_date).format('DD/MM/YYYY')
                  : '-'
              }
            })
          )
        }
      } else {
        Error_false(resp)
      }
    } catch (error) {
      Error_500(error)
    }
  }

  const [detailById, setdetailById] = useState()
  const showModalEditMember = (d) => {
    setdetailById(d)
    setIsModalOpenEditMember(true)
  }

  const handleCancelEditMember = () => {
    setIsModalOpenEditMember(false)
  }

  const dateToDay = new Date()

  const [IsExcel, setIsExcel] = useState(false)

  const handleExport = async () => {
    setIsExcel(true)

    const body = {
      fundId,
      page: 1,
      orgId: org?.value ?? '',
      size: totalRows
    }
    try {
      await fnGetData(body, true)
    } finally {
      setIsExcel(false)
    }
  }

  const exportExcel = async (data) => {
    const fileName = `all-member-report-EJIP-${moment(dateToDay).format(
      'YYYYMMDD'
    )}`
    const { sheetData, sheetOptions } = buildEjipAllMemberReportSheet({
      data
    })
    const blob = await createSpreadsheetBlob(sheetData, sheetOptions)

    saveAs(blob, `${fileName}.xlsx`)
    Swal.fire({
      title: 'success',
      text: 'Exported!',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500
    })
  }

  return (
    <Row>
      <NavTitle>
        <BtnBack className={'text-muted'} />
      </NavTitle>

      <Col xl={12}>
        <CardCustom className="h-full overflow-auto">
          <div className="d-flex gap-3 justify-content-between p-3">
            <label
              className=" my-auto fw-bold"
              style={{
                fontSize: '14px'
              }}
            >
              Total: {totalRows?.toLocaleString()}
            </label>
            <div className="d-flex justify-content-end ">
              <div className="me-3" style={{ minWidth: 150 }}>
                <Autocomplete
                  isClearable={true}
                  placeholder={'Org All'}
                  options={dataOrgs}
                  value={org}
                  onChange={(data) => {
                    const body = {
                      ...bodyFilter,
                      orgId: data?.value ?? ''
                    }
                    fnGetData(body)
                    setOrg(data)
                  }}
                />
              </div>
              <Form.Group style={{ minWidth: 300 }}>
                <InputGroup className="">
                  <InputGroup.Text className="bg-white border-end-0 text-muted">
                    <BsSearch />
                  </InputGroup.Text>
                  <Form.Control
                    className="border-start-0 ps-0"
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Name/ Code"
                  />
                </InputGroup>
              </Form.Group>
              <div
                className="col-3 "
                style={{
                  marginLeft: '20px'
                }}
              >
                <Button
                  disabled={IsExcel}
                  onClick={handleExport}
                  className="btn btn-orbit w-100 "
                  size="sm"
                >
                  {IsExcel ? 'Exporting...' : 'Export'}
                </Button>{' '}
              </div>
            </div>
          </div>
          <Table>
            <thead
              className="bg-hrms text-white "
              style={{ position: 'sticky', top: 0 }}
            >
              <tr className="">
                <th className="fw-normal small ">#</th>
                <th className="fw-normal small text-center">Image</th>

                <th className="fw-normal small ">Code</th>
                <th className="fw-normal small ">Name</th>
                <th className="fw-normal small text-center">Entry Date</th>
                <th className="fw-normal small text-center">Rounds</th>
                <th className="fw-normal small text-center">% Deducted</th>
                <th className="fw-normal small text-center">
                  Resignation Date
                </th>
                <th className="fw-normal small text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((d, i) => (
                  <tr className="fw-light font-small-2">
                    <td className=" fw-light">
                      {page * totalLimits - totalLimits + i + 1}
                    </td>
                    <td className="text-center fw-light">
                      <Image
                        fluid
                        className="rounded-circle "
                        style={{
                          maxWidth: 40,
                          maxHeight: 40,
                          objectFit: 'cover'
                        }}
                        //src={`${URL_PROFILE}/${d?.folder_img}/${d?.code}_cr.jpg`}
                        src={`${d?.img_url}`}
                        onError={(event) => {
                          event.target.src = imgUser
                          event.onerror = null
                        }}
                      />
                    </td>
                    <td className=" fw-light">{d.code}</td>

                    <td className="fw-light">
                      {d.title_th} {d.name_th}
                    </td>
                    <td className="text-center fw-light">
                      {moment(d.entry_date).format('DD/MM/YYYY')}
                    </td>
                    <td className="text-center fw-light">{d.round}</td>
                    <td className="text-center fw-light">{d.percentage}%</td>
                    <td className="text-center fw-light">
                      {d.resignation_date
                        ? moment(d.resignation_date).format('DD/MM/YYYY')
                        : '-'}
                    </td>
                    <td className="text-center fw-light">
                      <ButtonToolbar className="d-flex justify-content-center">
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip id="tooltip-detail">Edit</Tooltip>}
                        >
                          <Button
                            variant="btn btn-outline-primary"
                            className="border-0 "
                            size="sm"
                            style={{
                              width: '32px',
                              height: '32px'
                            }}
                            onClick={() => showModalEditMember(d)}
                          >
                            <Image src={editImg}></Image>
                          </Button>
                        </OverlayTrigger>
                      </ButtonToolbar>
                    </td>
                  </tr>
                ))
              ) : isLoading ? (
                <tr className="mb-0">
                  <td className="text-center" colSpan={13}>
                    <SpinnerLoading />
                  </td>
                </tr>
              ) : (
                <tr className="mb-0">
                  <td className="text-center" colSpan={13}>
                    -ไม่มีข้อมูล-
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
          <div className="pt-3">
            <PaginationControl
              page={page}
              total={totalRows}
              limit={totalLimits}
              changePage={(p) => {
                const body = {
                  ...bodyFilter,
                  page: p
                }
                fnGetData(body)
                setPage(p)
              }}
              ellipsis={1}
            />
          </div>
        </CardCustom>
      </Col>

      <MedalEditMember
        fnEffectData={() => fnGetData(bodyFilter)}
        isModalOpen={isModalOpenEditMember}
        handleCancel={handleCancelEditMember}
        detail={detailById}
        fundId={fundId}
      />
    </Row>
  )
}
